// @ts-nocheck
import { getIsAuthenticated } from "@store/Framework/Store/Foundation/Context/ContextSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { useSelector } from "react-redux";

export const useIsAuthenticated = () => {
    return useSelector((state: ApplicationState) => {
        return getIsAuthenticated(state);
    });
};

export const useDisplayName = () => {
    return useSelector((state: ApplicationState) => {
        const firstName = state.context.session.firstName;
        const userName = state.context.session.userName;
        const useEmailAsUsername = getSettingsCollection(state).accountSettings.useEmailAsUserName;
        const croppedEmail = userName ? userName.match(/([^@]+)([@])/) : null;

        return firstName || (useEmailAsUsername ? (croppedEmail ? croppedEmail[1] : userName) : userName);
    });
};
